import { useState } from 'react';
import { useCart } from './CartContext'; // Import Cart Hook
import './Contact.css'; 

const Contact = () => {
  const { cartItems } = useCart(); // Get cart data
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setMessage('');

    const formData = new FormData(e.target);

    // Prepare Payload WITH Cart items
    const cartPayload = cartItems.map(item => ({
      name: item.name,
      quantity: item.qtyCount,
      type: item.qtyType || 'Standard',
      price: item.price || 0
    }));

    const payload = {
      name: formData.get('user_name'),
      phone: formData.get('contact_no'),
      email: formData.get('user_email'),
      message: formData.get('message'),
      cart: cartPayload // <--- Now sending cart!
    };

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage('✅ Message sent successfully!');
        e.target.reset(); 
        // Note: We usually DO NOT clear the cart on a general contact form,
        // but if you want to, add: setCartItems([]);
      } else {
        throw new Error(result.error || "Failed to send");
      }
    } catch (error) {
      console.error("Contact Error:", error);
      setStatus('error');
      setMessage('❌ Failed to send. Please try again.');
    }
  };

  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <form onSubmit={handleSubmit} className="contact-form">
        <input type="text" name="user_name" placeholder="Your Name" required />
        <input type="tel" name="contact_no" placeholder="Contact Number" required />
        
        {/* Removed Alternate Phone as requested */}
        
        <input type="email" name="user_email" placeholder="Your Email" required />
        <textarea name="message" placeholder="Your Query" required></textarea>
        
        <button type="submit" disabled={status === 'sending'}>
          {status === 'sending' ? 'Sending...' : 'Contact'}
        </button>
      </form>
      
      {message && <p className={`confirmation-message ${status}`}>{message}</p>}
    </div>
  );
};

export default Contact;
